import { isEmpty } from 'underscore';
import { cleanUpSectionErrors } from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
// field types. ie, input boxes, drop downs ect
import {
  VF_BUTTON_SELECTOR,
  VFButtonSelector,
} from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  VF_DROPDOWN,
  VFDropdown,
} from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  VF_TEXTAREA,
  VFTextarea,
} from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  VF_PARAGRAPH,
  VFParagraph,
} from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';
import {
  VF_INPUT,
  VFInput,
} from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  VF_MODAL,
  VFModal,
} from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import {
  VFDropzone,
  VF_DROPZONE,
} from 'AppSrc/core/components/forms/form-base-components/v-f-dropzone';
import {
  VFSubSectionTitle,
  VF_SUB_SECTION_TITLE,
} from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';
import {
  VF_SUB_SECTION_TITLE1,
  VFSubSectionTitle1,
} from 'AppSrc/core/components/forms/form-base-components/v-f-section-header';
import {
  VFDatePicker,
  VF_DATE_PICKER,
} from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  VFCorrectiveDatePicker,
  VF_CORRECTIVE_DATE_PICKER,
} from 'AppSrc/core/components/forms/form-base-components/v-f-corrective-date-picker';
import {
  VFRadioButton,
  VF_RADIO_BUTTON,
} from 'AppSrc/core/components/forms/form-base-components/v-f-radio-button';
import {
  VF_MULTI_SELECT,
  VFMultiSelect,
  getTextForValuesMultiSelect,
} from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select';
import {
  VFTimeStamp,
  VF_TIME_STAMP,
} from 'AppSrc/core/components/forms/form-base-components/utility/v-f-time-stamp';
import {
  VF_LOOKUP_TABLE,
  VFLookupTable,
} from 'AppSrc/core/components/forms/form-base-components/v-f-lookup-table';
import { getSelectedOptionForDropdown } from 'AppSrc/core/components/forms/form-base-components/sub-components/drop-down-components/templates/dropdown-templates';
import { getDisplayOptionsToUse } from 'AppSrc/core/components/forms/data/get-display-options-to-use';
import {
  RAISING_CRQ,
  VIEWING_CRQ,
  ES_RAISING_NEW_SECTION,
  ES_RAISING_EDIT_SECTION,
  ES_RAISING_EDIT_FROM_SUMMARY,
  ES_VIEWING_EDIT_SECTION,
  ES_VIEWING_NEW_SECTION,
  RAISING_CRQ_EDITING_STATUSES,
  VIEWING_CRQ_EDITING_STATUSES,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  VF_SINGLE_RADIO,
  VFSingleRadio,
} from './form-base-components/v-f-single-radio';
import {
  VF_EDIT_TABLE,
  VFEditTable,
} from './form-base-components/v-f-edit-table';



// map of the field types so we know which component to render
const formFieldTypes = {
  [VF_BUTTON_SELECTOR]: VFButtonSelector,
  [VF_DROPDOWN]: VFDropdown,
  [VF_TEXTAREA]: VFTextarea,
  [VF_INPUT]: VFInput,
  [VF_MODAL]: VFModal,
  [VF_DROPZONE]: VFDropzone,
  [VF_SUB_SECTION_TITLE]: VFSubSectionTitle,
  [VF_SUB_SECTION_TITLE1]: VFSubSectionTitle1, // For Outage window title in section3.
  [VF_DATE_PICKER]: VFDatePicker,
  [VF_CORRECTIVE_DATE_PICKER]: VFCorrectiveDatePicker,
  [VF_TIME_STAMP]: VFTimeStamp,
  [VF_PARAGRAPH]: VFParagraph,
  [VF_MULTI_SELECT]: VFMultiSelect,
  [VF_LOOKUP_TABLE]: VFLookupTable,
  [VF_RADIO_BUTTON]: VFRadioButton, // NOT FULLY IMPLEMENTED!
  [VF_SINGLE_RADIO]: VFSingleRadio,
  [VF_EDIT_TABLE]: VFEditTable,
};

const nonDataFormFields = [
  VF_SUB_SECTION_TITLE,
  VF_SUB_SECTION_TITLE1,
  VF_PARAGRAPH,
];

// not all formFields save data. Some formFields are purely decoration (such as sub section titles);
// In this regard we can't call them formFields in a traditional sense but we classifiy them as formFields
// as they appear in formSections
const formFieldSavesData = (fieldId) => !nonDataFormFields.includes(fieldId);



// The form does different things during different flows
const getEditingStatus = (params = {}) => {
  const {
    // editing via the back button
    isNavEditing,
    // editing on a section by section bases from the summary page
    isSummaryEditing,
    flow,
  } = params;

  const isEditing = isNavEditing || isSummaryEditing;

  const triggerErrorMessage = (fallbackType) => {
    console.error(`Cannot find editStatus for flow: ${flow}, isEditing: ${isEditing}. Falling back to: ${fallbackType}`);
  };

  if (flow === RAISING_CRQ) {
    if (isEditing !== true) {
      // first time the section has been displayed to the user, has no existing state in redux
      return ES_RAISING_NEW_SECTION;
    }
    if (isNavEditing === true) {
      // the user has seen this section before and it has been saved in redux via the next or back button
      // the user navigated to this section via the next or back button
      return ES_RAISING_EDIT_SECTION;
    }
    if (isSummaryEditing === true) {
      // the user has seen this section before and it has been saved in redux via the next or back button
      // the user navigated to this section via the summary section
      return ES_RAISING_EDIT_FROM_SUMMARY;
    }
    // this fallback assumes there is no state in redux. As such it protects us from crashes caused by trying
    // to crunch data that doesn't exist
    const fallback = ES_RAISING_NEW_SECTION;
    triggerErrorMessage(fallback);
    return fallback;
  }

  if (flow === VIEWING_CRQ) {
    if (isEditing !== true) {
      // the user is viewing a CRQ as is
      return ES_VIEWING_NEW_SECTION;
    }
    if (isEditing === true) {
      // the user is editing a CRQ and needs to be aware of things like inline errors
      return ES_VIEWING_EDIT_SECTION;
    }
    // this fallback has least assumptions
    const fallback = ES_VIEWING_NEW_SECTION;
    triggerErrorMessage(fallback);
    return fallback;
  }

  // ES_VIEWING_NEW_SECTION this fallback has the least amount of assumptions and edits the least amount of data
  const finalFallback = ES_VIEWING_NEW_SECTION;
  triggerErrorMessage(finalFallback);

  return finalFallback;
};

const getFormFlowForEditingStatus = (editingStatus) => {
  if (RAISING_CRQ_EDITING_STATUSES.includes(editingStatus)) {
    return RAISING_CRQ;
  }
  if (VIEWING_CRQ_EDITING_STATUSES.includes(editingStatus)) {
    return VIEWING_CRQ;
  }
  console.warn(`No form flow found for editing status ${editingStatus}`);
  return null;
};

// utility function for getting the specific displayOption/s
// For example a fields values may be `true` or `false`. However their display values may be "Yes" or "No"
const getDisplayValues = (params) => {
// Freyja: 19/03/2020 🔥🔥🔥
// #TODO This function exists to get the display text for a field. Ideally it should be called: getDisplayText
// Likewise, with dropDowns and button selectors it's returning an array of displayOptions. It should probably
// just be returning an array of text, as the array of display values is stores in the fields value
// ALSO we're currently just letting VF_DATE_PICKER values bleed through when we should probably format them here???

  const {
    fieldType,
    displayOptions,
    value,
    vFParams,
  } = params;

  const selectedOptionBlank = {
    text: '-',
    value: '-',
  };

  if (fieldType === VF_BUTTON_SELECTOR) {
    const displayValues = displayOptions.filter((item) => value.includes(item.value));
    // if there is no value, return a blank value
    return displayValues.length > 0 ? displayValues : [selectedOptionBlank];
  }

  if (fieldType === VF_DROPDOWN) {
    const {
      optionTemplate,
    } = vFParams;

    const selectedOption = getSelectedOptionForDropdown({
      optionTemplate,
      displayOptions,
      value,
    });
    const displayValue = selectedOption ? selectedOption : selectedOptionBlank;
    // getDisplayValues has to return an array to support multi value fields
    // wrap our single value in an array before returning

    return [displayValue];
  }

  if (fieldType === VF_TEXTAREA) {
    return value ? value : '-';
  }

  if (fieldType === VF_INPUT) {
    return value ? value : '-';
  }

  if (fieldType === VF_DATE_PICKER) {
    // we let the value of dates bleed through and let their summary section deal with them
    // though we should probably deal with that logic here... We can do that as part of the
    // refactor mentioned above.
    return value;
  }

  if (fieldType === VF_MULTI_SELECT) {
    const textValues = getTextForValuesMultiSelect({
      displayOptions,
      value,
      vFParams,
    });

    return textValues;
  }

  // modals should just bleed straight through, they have very complicated data structures that they
  // manage themselves and have their own summary components for
  if (fieldType === VF_MODAL) {
    return value;
  }

  console.warn(`Cannot find display value for fieldType: ${fieldType}, with value: ${value}`);

  // return value as a fallback
  return value;
};

// extracts the existing field value out of the data
const getExistingFieldValue = (fieldName, currentSectionData) => {
  if (!currentSectionData) {
    return undefined;
  }
  if (!currentSectionData.dataByFieldId[fieldName]) {
    return undefined;
  }
  return currentSectionData.dataByFieldId[fieldName].value;
};

// This handles validation for every field returned by a form sections getCurrentFields method
const validateFormFields = (params) => {

  const {
    currentFields,
    values,
    userRoles,
    formData,
    outerFormData,
    sectionId,
  } = params;

  const errors = {};

  currentFields.forEach((field, i) => {
    if (field.shouldValidate) {
      const id = field.componentData.id ? field.componentData.id : null;
      errors[id] = field.componentData.validator({
        values,
        field,
        userRoles,
        formData,
        outerFormData,
        sectionId,
      });
    }
  });
  // Removes empty keys from the errors object
  return cleanUpSectionErrors(errors);
};

// in reality this only hints to the user that the form might be in a submittable state.
// Formik still handles it's submit hooks when the user clicks submit, this just gives
// a visual que to the user saying it wont work
const isSectionReadyToSubmit = (errors) => {
  // there are errors, so the form cannot proceed to the next section
  if (!isEmpty(errors)) {
    return false;
  }
  return true;
};

// As the form usually has errors from fields not field in ect, we typically hide them from the user
// until they have touched that field. This function tells the form section if any of the forms errors
// are visable
const inlineErrorsAreViewable = (errors, touched) => {
  const keys = Object.keys(touched);
  let viewableErrors = false;
  keys.forEach((touchedItem) => {
    // if the field has not been touched, we skip it
    if (!touched[touchedItem]) {
      return null;
    }

    // we only care about inlineErrors for this
    if (errors[touchedItem] && errors[touchedItem].inlineErrors) {
      viewableErrors = true;
      return null;
    }

    return null;
  });
  return viewableErrors;
};

const silentErrorsAreViewable = (errors, touched) => {
  const keys = Object.keys(touched);
  let viewableErrors = false;
  keys.forEach((touchedItem) => {
    // if the field has not been touched, we skip it
    if (!touched[touchedItem]) {
      return null;
    }

    // we only care about inlineErrors for this
    if (errors[touchedItem] && errors[touchedItem].silentErrors) {
      viewableErrors = true;
      return null;
    }

    return null;
  });
  return viewableErrors;
};


// A utility function for the createFieldDataObjAndArray utility function :)
const getVFTypeSpecificOptions = (params) => {
  const {
    fieldType,
    vFParams,
  } = params;

  if (fieldType === VF_MODAL) {
    const {
      modalSummaryType,
      modalErrorsTitle,
    } = vFParams;
    return ({
      modalSummaryType, // To display the same section summary from the field level on the section summary page
      modalErrorsTitle, // To display the same error message on the section summary page
    });
  }

  // add some extra display options to vf multi select for the summary
  if (fieldType === VF_MULTI_SELECT) {
    const {
      hideSummaryTitle,
      showSummaryAsList,
    } = vFParams;
    return ({
      hideSummaryTitle,
      showSummaryAsList,
    });
  }

  return null;
};

// FN: 25/03/2020
// To get the display options to use we use a function called: getDisplayOptionsToUse
// This function can accept a network as a paramater in which case it will return the
// display options for that network. Alternatively it can give you the display options
// for all the variations of that compondentData's fieldId. This is useful if a dropdown
// sources it's display optoins from a dynamically created key (instead of using it's
// regular fieldId). Where this breaks down though is some values for
// selectedNetwork: mobile conflict with selectedNetwork: fixed. As such, we should
// always try and get display options for a network before falling back on all of the
// available display options
const getDisplayOptionsToUseFromMultipleSources = ({
  componentData,
  selectedNetwork,
}) => {

  if (!selectedNetwork) {
    console.warn(`Unable to determine selectedNetwork! This means the display options for the component with an
    id: ${componentData.id} may have the incorrect text value displayed to the user!`);
  }

  if (selectedNetwork) {
    const displayOptionsForNetwork = getDisplayOptionsToUse({
      componentData,
      selectedNetwork,
    });

    if (displayOptionsForNetwork && displayOptionsForNetwork.length > 0) {
      return displayOptionsForNetwork;
    }
  }

  const displayOptionsFromAll = getDisplayOptionsToUse({
    componentData,
    getAllOptions: true,
  });


  return displayOptionsFromAll;
};



// Function for enriching the data so that it can be used as a single source of truth for:
// 1. The value to submit to server
// 2. What that value looks like to the user (ux)
// 3. If we actually tell the user that value exists
// This function also overwrites the values per one of the requirments
const createFieldDataObjAndArray = ({
  currentFields,
  values,
  selectedNetwork,
  noOverwrite,
}) => {
  const data = {
    // this is for sending to server
    dataByFieldId: {},
    // this is to show the user
    fieldIdsByDisplayOrder: [],
  };

  currentFields.forEach((field, i) => {
    const {
      componentData,
      overwriteSubmit,
      disabledFieldOptions,
    } = field;

    const {
      id,
      vFParams,
      fieldType,
    } = componentData;

    if (!formFieldSavesData(fieldType)) {
      return null;
    }

    const displayOptions = getDisplayOptionsToUseFromMultipleSources({
      componentData,
      selectedNetwork,
    });

    const {
      fieldTitle,
    } = vFParams;

    // sets the value!
    const value = values[id];

    if (value === undefined) {
      // we treat undefined as a mistake in general. If you want your value to be falsy, please default to null
      console.warn(`Value for ${id} was found to be undefined. This is most likely an error, please set the value to null if not.`);
    }
    // if the field is disabled though, sets the disabled value (this usually happens at render time but this
    // function can get called by redux)
    const newValue = disabledFieldOptions.disabled ? disabledFieldOptions.disabledValue : value;
    // we should overwrite if the overwriteSubmit value is true, unless the noOverwrite option was passed in
    const shouldOverwrite = overwriteSubmit.overwrite && noOverwrite !== true;
    // if we are overwriting the value based on a specific requirement form the client though, we ignore everything
    // and use that value instead
    const valueToSubmit = shouldOverwrite ? overwriteSubmit.overwriteValue : newValue;
    // If we are overwriting the value, we assume that it should also be hidden from the summary view
    const hideFromSummary = shouldOverwrite;

    // as we don't store the displayOptions within forkmik's Values (and it would get complicated to do so)
    // we have to use this function to get the displayValuess for the relevant value for the change summary page

    const displayValues = getDisplayValues({
      fieldType,
      displayOptions,
      value,
      vFParams,
    });

    // gives the developer a helpful message when there is a bug caused by a default value not being found in the list
    // of values available in displayValues. We check if displayOptions has a length > 0 as well as displayValues having
    // a length of 0 as if there are displayOptions available no displayValue has been for the value given, that suggests
    // something has gone wrong
    if (value !== null && ((displayOptions && displayOptions.length > 0) && (displayValues.length === 0))) {
      console.warn(`CANNOT LOCATE THE DISPLAY VALUE OF '${value}' IN ARRAY [${displayOptions.map((item) => item.value).join()}] FOR: '${id}'.`);
    }

    const vFTypeSpecificOptions = getVFTypeSpecificOptions({
      fieldType,
      vFParams,
    });


    data.dataByFieldId[id] = {
      value: valueToSubmit,
      displayValues,
      hideFromSummary,
      fieldTitle,
      fieldType,
      vFTypeSpecificOptions,
    };
    data.fieldIdsByDisplayOrder.push(id);

    // this loop doesn't technically return anything but we no op earlier for components that aren't technically
    // form fields. As such we have to return null here to please the goddess lint
    return null;
  });
  return data;
};


// extracts out an object of the initial values of a form
const getInitialValues = ({
  formData,
  userRoles,
  getCurrentFields,
  sectionId,
  outerFormData,
}) => {
  const currentSectionData = formData.dataByFormSectionId[sectionId];



  const formInitialValues = {};

  const initialFields = getCurrentFields({
    // FN: 2/12/2019
    // it's unlikely that we really need to pass in paramatars at all. It's mainly to stop form sections crashing
    // the reason for this is all we're doing here is getting a list of all the form fields and what their initial
    // value is
    formData,
    userRoles,
    outerFormData,
  });

  initialFields.forEach((field, i) => {
    const {
      id,
      fieldType,
      // FN:
      // This should have been called initialValue to be consistant with formik but unfortunatly I
      // called it initialValues ages ago because a form field can have multiple values in an array
      initialValues,
    } = field.componentData;

    if (formFieldSavesData(fieldType)) {
      const existingFieldValue = getExistingFieldValue(id, currentSectionData);
      if (initialValues === undefined) {
        // if this occures formik will act as though it is updating values, but it wont actually be doing so
        console.error(`FORMIK CANNOT ACCEPT undefined AS AN INITIAL VALUE. CHECK THE INITIAL VALUE OF ${id}`);
      }
      formInitialValues[id] = existingFieldValue ? existingFieldValue : initialValues;
    }

  });
  return formInitialValues;

};

const createFormDataMap = (formData) => formData.formSectionsByDisplayOrder.map((sectionId, i) => formData.dataByFormSectionId[sectionId]);

export {
  getEditingStatus,
  getFormFlowForEditingStatus,
  formFieldTypes,
  getDisplayValues,
  getExistingFieldValue,
  validateFormFields,
  isSectionReadyToSubmit,
  inlineErrorsAreViewable,
  silentErrorsAreViewable,
  createFieldDataObjAndArray,
  getInitialValues,
  createFormDataMap,
};

